var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`
info-card-wrapper
${_vm.borderLeft ? 'border-left' : '' }
${_vm.borderRight ? 'border-right' : '' }`,style:(`
border-left-color: ${_vm.borderLeftColor};
border-right-color: ${_vm.borderRightColor};  
`)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }